<template>
  <div class="deferred-content-placeholder">
    <!-- eslint-disable-next-line vue/html-self-closing -->
    <div class="deferred-content-throbber"></div>
  </div>
</template>

<script>
// Pure CSS, no script logic - safe to render during SSR (unlike
// @aspedia/loading-spinner, which touches `document` in its own lifecycle
// hooks and crashes the SSR render). The throbber animates via @keyframes
// alone, so once rendered it's already spinning on first paint, through
// hydration, until the deferred content it stands in for arrives and
// replaces it.
//
// The throbber div must use an explicit closing tag, not a self-closing
// <div ... />: vue-server-renderer drops the content of self-closed
// non-void elements during SSR (div isn't a void element per the HTML
// spec), so with the self-closing form this element was completely absent
// from the SSR HTML - just an empty placeholder box, no spinner - while
// still rendering correctly client-side, since Vue's runtime render
// function isn't affected by the same SSR string-serialization shortcut.
// Confirmed by inspecting raw SSR output directly: the placeholder div's
// background showed, but it had zero children.
export default {
  name: 'deferred-content-placeholder'
}
</script>

<style scoped lang="scss">
.deferred-content-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 6em;
  background-color: #eee;
  border-radius: 4px;
}

.deferred-content-throbber {
  width: 2.5em;
  height: 2.5em;
  border: 4px solid rgba(0, 0, 0, 0.3);
  border-top-color: rgba(0, 0, 0, 0.8);
  border-radius: 50%;
  animation: deferred-content-throbber-spin 0.8s linear infinite;
}

@keyframes deferred-content-throbber-spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
